// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r24z5","footer":"styles_footer__1BGsa","passCodeTooltip":"styles_passCodeTooltip__VOJLO"};